const initialState = () => ({
  notifications: [],
  showPanelColumns: false,
});

export default {
  namespaced: true,
  state: initialState,
  actions: {
    add({ commit, dispatch }, payload) {
      const id = Date.now();
      commit('add', { ...payload, id });
      setTimeout(() => dispatch('remove', id), 15000);
    },
    remove({ commit }, payload) {
      commit('remove', payload);
    },
    clear({ commit }) {
      commit('clear');
    },
  },
  mutations: {
    add(state, data) {
      state.notifications.push(data);
    },
    remove(state, id) {
      state.notifications = state.notifications.filter((n) => n.id !== id);
    },
    clear(state) {
      state.notifications = [];
    },
    setShowPanelColumns(state, data) {
      state.showPanelColumns = data;
    },
  },
  getters: {
    notifications: (state) => state.notifications,
    showPanelColumns: (state) => state.showPanelColumns,
  },
};
